import { render, staticRenderFns } from "./PaxSimulationList.vue?vue&type=template&id=7faebf7a&"
import script from "./PaxSimulationList.vue?vue&type=script&lang=js&"
export * from "./PaxSimulationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports